import { apiGet, apiPost } from "utils/apiClient";

export type DismissedGroupIdsResponse = { ids: string[] };

export async function fetchDismissedGroupNotifications(token: string): Promise<DismissedGroupIdsResponse> {
    return apiGet<DismissedGroupIdsResponse>("/users/notification-dismissals/groups", token);
}

export async function dismissGroupNotifications(
    token: string,
    ids: string[],
): Promise<DismissedGroupIdsResponse> {
    return apiPost<DismissedGroupIdsResponse>("/users/notification-dismissals/groups", { ids }, token);
}
